import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useDashboardStore } from "../../services/useDashboardStore";
import CrmFunnelWidget from "./CrmFunnelWidget";
import AutomationsWidget from "./AutomationsWidget";
import IntegrationsWidget from "./IntegrationsWidget";
import TeamMetricsWidget from "./TeamMetricsWidget";
import ActivityFeed from "./ActivityFeed";
import "./Home.css";
import FullScreenLoader from "../FullScreenLoader/FullScreenLoader";
const Home = () => {
  const navigate = useNavigate();
  const { dashboardData, loading, error, fetchDashboard } = useDashboardStore();

  useEffect(() => {
    fetchDashboard();

    const interval = setInterval(() => {
      fetchDashboard();
    }, 60000);

    return () => clearInterval(interval);
  }, [fetchDashboard]);

  if (loading && !dashboardData) {
    return (
      <div className="home">
        <div style={{ padding: "40px", textAlign: "center" }}>
          < FullScreenLoader message="Carregando Dashboard..." />
        </div>
      </div>
    );
  }

  if (error && !dashboardData) {
    return (
      <div className="home">
        <div style={{ padding: "40px", textAlign: "center", color: "#e74c3c" }}>
          <p>Error loading dashboard: {error}</p>
          <button onClick={fetchDashboard} className="home-btn-primary">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="home">

      <motion.header
        className="home-header"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div>
          <p className="home-kicker">Dashboard Executivo</p>
          <h1 className="home-title">Seja bem vindo a plataforma FastTeam</h1>
          <p className="home-subtitle">
            Monitoramento completo em um só lugar. Veja os dados de sua operação, dados do CRM, automações,
             integrações e desempenho da equipe.
          </p>
        </div>
        <div className="home-header-actions">
          {/* <button
            className="home-btn-secondary"
            onClick={() => navigate("/relatorios")}
          >
            View Reports
          </button> */}
          <button
            className="home-btn-primary"
            onClick={() => navigate("/crm")}
          >
            + Novo Lead
          </button>
        </div>
      </motion.header>

      <motion.section
        className="home-stats-grid"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "15px",
          marginBottom: "30px",
        }}
      >
        <motion.button
          className="home-stat-card"
          whileHover={{ y: -4 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          onClick={() => navigate("/crm")}
          style={{
            cursor: "pointer",
            border: "none",
            textAlign: "left",
            background: "var(--success)",
          }}
        >
          <p className="home-stat-label">CRM</p>
          <p className="home-stat-value">
            {dashboardData?.crm_summary?.total_leads || 0}
          </p>
          <p className="home-stat-tag">Total Leads</p>
        </motion.button>

        <motion.button
          className="home-stat-card"
          whileHover={{ y: -4 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          onClick={() => navigate("/smartflow")}
          style={{
            cursor: "pointer",
            border: "none",
            textAlign: "left",
            background: "var(--success)",
          }}
        >
          <p className="home-stat-label">Fluxos Inteligentes</p>
          <p className="home-stat-value">
            {dashboardData?.automations?.total_active || 0}
          </p>
          <p className="home-stat-tag">Ativos</p>
        </motion.button>

        <motion.button
          className="home-stat-card"
          whileHover={{ y: -4 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          onClick={() => navigate("/operation-team")}
          style={{
            cursor: "pointer",
            border: "none",
            textAlign: "left",
            background: "var(--success)",
          }}
        >
          <p className="home-stat-label">Atividades</p>
          <p className="home-stat-value">
            {dashboardData?.team_metrics?.leads_today || 0}
          </p>
          <p className="home-stat-tag">Novos Leads</p>
        </motion.button>

        <motion.button
          className="home-stat-card"
          whileHover={{ y: -4 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          onClick={() => navigate("/integrations")}
          style={{
            cursor: "pointer",
            border: "none",
            textAlign: "left",
            background: "var(--success)",
          }}
        >
          <p className="home-stat-label">Integrações</p>
          <p className="home-stat-value">
            {dashboardData?.integrations?.total_configured || 0}
          </p>
          <p className="home-stat-tag">Conectadas</p>
        </motion.button>
      </motion.section>

      <section
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
          gap: "20px",
          marginBottom: "30px",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.15 }}
        >
          <CrmFunnelWidget crmSummary={dashboardData?.crm_summary} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          <AutomationsWidget automations={dashboardData?.automations} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.25 }}
        >
          <IntegrationsWidget integrations={dashboardData?.integrations} />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.3 }}
        >
          <TeamMetricsWidget teamMetrics={dashboardData?.team_metrics} />
        </motion.div>
      </section>

      <motion.section
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.35 }}
      >
        <ActivityFeed activities={dashboardData?.recent_activities} />
      </motion.section>
    </div>
  );
};

export default Home;
